import { MetaData } from './../../types/MetaData';
import { siteUrl } from '@utils/siteConfig';
import { graphql, useStaticQuery } from 'gatsby';
import { keysToCamel } from '@utils/snakeCaseParser';
import React from 'react';

const useMetaData = (pageUrl: string) => {
	const { directus } = useStaticQuery(graphql`
		query metaaData {
			directus {
				meta_data(sort: "page_url") {
					page_url
					title
					og_title
					meta_description
					og_description
					og_image {
						id
						imageFile {
							publicURL
						}
					}
				}
			}
		}
	`);

	const allPagesMetaData: { metaData: MetaData[] } = React.useMemo(
		() => keysToCamel(directus),
		[directus]
	);

	const getMetaData = () => {
		const metaData =
			allPagesMetaData.metaData.find((el) => {
				return el.pageUrl === pageUrl;
			}) || allPagesMetaData.metaData[0];
		const pageMetaData = {
			...metaData,
			ogImage:
				siteUrl + allPagesMetaData.metaData[0].ogImage.imageFile.publicURL,
		};
		if (metaData.ogImage) {
			pageMetaData.ogImage = siteUrl + metaData.ogImage.imageFile.publicURL;
		}
		delete pageMetaData.pageUrl;
		return { metaData: pageMetaData };
	};
	return getMetaData();
};
export default useMetaData;
